import { EventName } from '../constants';
import { createAndSendEvent } from '../jumboClient';

export const IssueClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.ISSUE_CLICKED, properties);
export const UploadComplaintMediaClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.UPLOAD_COMPLAINT_MEDIA_CLICKED, properties);
export const ViewAndUploadModalClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.VIEW_UPLOAD_MODAL_CLICKED, properties);
export const RefreshMediaClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.REFRESH_MEDIA_CLICKED, properties);
export const DeleteComplaintMediaInModalEvent = (properties = {}) =>
  createAndSendEvent(EventName.DELETE_COMPLAINT_MEDIA_IN_MODAL, properties);
export const IssueItemQuantityUpdateEvent = (properties = {}) =>
  createAndSendEvent(EventName.ISSUE_ITEM_QUANTITY_UPDATED, properties);
export const IssueItemPickupClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.ISSUE_ITEM_PICKUP_CLICKED, properties);
export const IssueItemCustomRefundUpdateEvent = (properties = {}) =>
  createAndSendEvent(EventName.ISSUE_ITEM_CUSTOM_REFUND_UPDATED, properties);
export const RaiseAnIssueNextBtnClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.RAISE_AN_ISSUE_NEXT_BTN_CLICKED, properties);
export const IssueItemEditUploadMediaClickEvent = (properties = {}) =>
  createAndSendEvent(
    EventName.ISSUE_ITEM_EDIT_UPLOAD_MEDIA_CLICKED,
    properties,
  );
export const IssueItemEditDetailsClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.ISSUE_ITEM_EDIT_DETAILS_CLICKED, properties);
export const IssueItemResolutionSelectionEvent = (properties = {}) =>
  createAndSendEvent(EventName.ISSUE_RESOLUTION_SELECTED, properties);
export const IssueResolveNowBtnClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.ISSUE_RESOLVE_NOW_BTN_CLICKED, properties);
export const VerifyAddressBtnClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.VERIFY_ADDRESS_BTN_CLICK_EVENT, properties);

// Lifeline IVA Events
export const IVAApproveRejectBtnClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.IVA_APPROVE_REJECT_BTN_CLICKED, properties);
export const IVAReasonSelectionEvent = (properties = {}) =>
  createAndSendEvent(EventName.IVA_REASON_SELECTION, properties);
export const IVAApprovalContinueBtnClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.IVA_APPROVAL_CONTINUE_BTN_CLICKED, properties);
export const IVAFinalResolutionEvent = (properties = {}) =>
  createAndSendEvent(EventName.IVA_FINAL_RESOLUTION, properties);
